module.exports = __webpack_public_path__ + "img/US_Speed_ua.0383def9.webp";